export default __webpack_public_path__ + "static/media/soulection-vinyl.070c1449.gif";